import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { sortToDTO, workspacePrebidModulesFromDTO } from './api/mapper'
import { GET_WORKSPACE_PREBID_MODULES } from './api/query'
import { Data, Variables, WorkspacePrebidModuleSliceDTO } from './api/types'
import {
  UseGetWorkspacePrebidModules,
  UseGetWorkspacePrebidModulesProps,
  WorkspacePrebidModuleSlice,
} from './types'

export const useGetWorkspacePrebidModules = ({
  first,
  last,
  moduleType,
  sort,
  workspaceId,
}: UseGetWorkspacePrebidModulesProps): UseGetWorkspacePrebidModules => {
  const [workspacePrebidModules, setWorkspacePrebidModules] = useState<
    WorkspacePrebidModuleSlice[]
  >([])
  const [count, setCount] = useState<number>(0)

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const { nodes: workspacePrebidModules, totalCount: count } = data.workspacePrebidModules

      if (workspacePrebidModules) {
        setWorkspacePrebidModules(
          workspacePrebidModules.map(
            (node: WorkspacePrebidModuleSliceDTO): WorkspacePrebidModuleSlice =>
              workspacePrebidModulesFromDTO(node),
          ),
        )
        setCount(count)
      }
    },
    query: GET_WORKSPACE_PREBID_MODULES,
    variables: {
      first,
      last,
      moduleType,
      sort: sortToDTO(sort),
      workspaceId,
    },
  })

  return {
    count,
    loading: isLoading,
    workspacePrebidModules,
  }
}
